import { createContext } from "react";
import { ITesting } from "../types";
import { Dispatch } from "react";
import { TestActions } from "./testActions";

export const initialTestState: ITesting = {
  Questions: [],
  IsQuestionFormOpen: false,
  MinCorrectAnswersCount: 1
};

export const TestContext = createContext<{ state: ITesting; dispatch: Dispatch<TestActions> }>({
  state: initialTestState,
  dispatch: () => undefined
});
